import React, { Fragment } from "react";

import { Box, Stack, Typography } from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";

export function MobileStepperHeader(props: {
  activeStep: number;
  labels: string[];
}) {
  const { activeStep, labels } = props;

  return (
    <Stack spacing={1.5} sx={{ pb: 1 }}>
      <Typography variant="h5" fontWeight={700}>
        {/* Novo Pedido */}
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `repeat(${labels.length * 2 - 1}, 1fr)`,
          alignItems: "start",
          columnGap: 1,
        }}
      >
        {labels.map((label, i) => {
          const done = i < activeStep;
          const active = i === activeStep;

          return (
            <Fragment key={label}>
              {/* Coluna do step (círculo + label alinhado abaixo) */}
              <Stack spacing={0.5} alignItems="center" sx={{ minWidth: 48 }}>
                <Box
                  sx={{
                    display: "grid",
                    placeItems: "center",
                    width: 24,
                    height: 24,
                    borderRadius: "50%",
                    bgcolor: done || active ? "primary.main" : "grey.400",
                    color: "common.white",
                    fontSize: 12,
                    fontWeight: 700,
                  }}
                >
                  {done ? <CheckIcon sx={{ fontSize: 16 }} /> : i + 1}
                </Box>

                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    lineHeight: 1.2,
                    // NOTE: destacar label do step ativo
                    color: active ? "text.primary" : "text.secondary",
                    fontWeight: active ? 600 : 400,
                  }}
                >
                  {label}
                </Typography>
              </Stack>

              {/* Segmento de linha entre este step e o próximo */}
              {i < labels.length - 1 ? (
                <Box
                  sx={{
                    mt: "12px",
                    height: 2,
                    width: "100%",
                    bgcolor: done ? "error.main" : "grey.300",
                  }}
                />
              ) : null}
            </Fragment>
          );
        })}
      </Box>
    </Stack>
  );
}
